/*
Akhila 12/26/2022 3075154998 Added Add Rule Popup
Akhila 12/28/2022 3075154998 Added Add  Action popUp and Added Fields
Prakash 01/16/2023 3075154998 Fixed Responsiveness.
Ravi 02/10/2023 3075154998 Rename placeholder in Operators and Fields.
Ravi 04/04/2023 3075154998 Fixed dropdown issue of fields.
Prakash 16/05/2023 3075154998 Fixed specing issue in tab view

*/
import {Button, withStyles} from '@material-ui/core';
import {Autocomplete} from '@mui/material';
import React, {useContext} from 'react';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
const DefaultOpenAutoComplete = withStyles({
  popperDisablePortal: {
    // position: "relative !important",
  },
})(Autocomplete);
const ActionAddRuleSelectFields = ({
  label,
  options = [],
  optionLable,
  groupBy,
  value,
  name,
  handleChange,
  renderOption,
  handleInsert,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  return (
    <div className="global-field-textfields add-calculation-rule new-standard-textfields col-md-6 col-xl-3 col-lg-4 Operators-field">
      <DefaultOpenAutoComplete
        classes={{
          option: classes.option,
        }}
        size="small"
        value={value}
        name="function"
        options={options ? options : []}
        groupBy={groupBy}
        getOptionLabel={optionLable}
        onChange={handleChange}
        renderOption={renderOption}
        fullWidth
        open={true}
        disablePortal
        autoSelect={false}
        ListboxProps={{
          style: {
            maxHeight: '130px',
          },
        }}
        renderInput={(params) => (
          <div className="select-field">
            <GuiTextField
              {...params}
              variant="outlined"
              margin="dense"
              InputLabelProps={{
                shrink: true,
              }}
              label={label}
              className={` ${classes.labelName}`}
              placeholder={`Select ${label}`}
            />
          </div>
        )}
      />
      <Button
        variant="outlined"
        onClick={handleInsert}
        className={`reset-btn ml-1 mb-2 ${classes.buttonRoot} box-btn`}
      >
        Insert
      </Button>
    </div>
  );
};

export default ActionAddRuleSelectFields;
